import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="uxppanelinfo" id="uxppanelinfo"></a>
    <h1 {...{
      "id": "uxppanelinfo"
    }}>{`UxpPanelInfo`}</h1>
    <a name="new-uxppanelinfo-new" id="new-uxppanelinfo-new"></a>
    <h2 {...{
      "id": "uxppanelinfo-1"
    }}>{`UxpPanelInfo()`}</h2>
    <p>{`Class describing a panel of the plugin.`}</p>
    <a name="uxppanelinfo-id" id="uxppanelinfo-id"></a>
    <h2 {...{
      "id": "id--string"
    }}>{`id : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get panel id`}</p>
    <a name="uxppanelinfo-label" id="uxppanelinfo-label"></a>
    <h2 {...{
      "id": "label--string"
    }}>{`label : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get panel label, localized string`}</p>
    <a name="uxppanelinfo-description" id="uxppanelinfo-description"></a>
    <h2 {...{
      "id": "description--string"
    }}>{`description : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get panel description, localized string`}</p>
    <a name="uxppanelinfo-shortcut" id="uxppanelinfo-shortcut"></a>
    <h2 {...{
      "id": "shortcut--object"
    }}>{`shortcut ⇒ `}<inlineCode parentName="h2">{`Object`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get panel shortcut`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Object`}</inlineCode>{` - which consists of following keys:
{string} shortcutKey
{boolean} commandKey
{boolean} altKey
{boolean} shiftKey
{boolean} ctrlKey  `}</p>
    <a name="uxppanelinfo-title" id="uxppanelinfo-title"></a>
    <h2 {...{
      "id": "title--string"
    }}>{`title : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get panel title, localized string`}</p>
    <a name="uxppanelinfo-icons" id="uxppanelinfo-icons"></a>
    <h2 {...{
      "id": "icons--array"
    }}>{`icons ⇒ `}<inlineCode parentName="h2">{`Array`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get panel icons`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Array`}</inlineCode>{` - each object contains following properties:
{string} path
{Array of Number} scale
{Array of string} theme
{Array of string} species  `}</p>
    <a name="uxppanelinfo-minimumsize" id="uxppanelinfo-minimumsize"></a>
    <h2 {...{
      "id": "minimumsize--object"
    }}>{`minimumSize ⇒ `}<inlineCode parentName="h2">{`Object`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get panel minimum size`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Object`}</inlineCode>{` - each object contains following properties:
{Number} width
{Number} height  `}</p>
    <a name="uxppanelinfo-maximumsize" id="uxppanelinfo-maximumsize"></a>
    <h2 {...{
      "id": "maximumsize--object"
    }}>{`maximumSize ⇒ `}<inlineCode parentName="h2">{`Object`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get panel maximum size`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Object`}</inlineCode>{` - each object contains following properties:
{Number} width
{Number} height  `}</p>
    <a name="uxppanelinfo-preferreddockedsize" id="uxppanelinfo-preferreddockedsize"></a>
    <h2 {...{
      "id": "preferreddockedsize--object"
    }}>{`preferredDockedSize ⇒ `}<inlineCode parentName="h2">{`Object`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get panel preferred docked size`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Object`}</inlineCode>{` - each object contains following properties:
{Number} width
{Number} height  `}</p>
    <a name="uxppanelinfo-preferredfloatingsize" id="uxppanelinfo-preferredfloatingsize"></a>
    <h2 {...{
      "id": "preferredfloatingsize--object"
    }}>{`preferredFloatingSize ⇒ `}<inlineCode parentName="h2">{`Object`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get panel preferred floating size`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Object`}</inlineCode>{` - each object contains following properties:
{Number} width
{Number} height  `}</p>
    <a name="uxppanelinfo-menuitems" id="uxppanelinfo-menuitems"></a>
    <h2 {...{
      "id": "menuitems--uxpmenuitems"
    }}>{`menuItems : `}<inlineCode parentName="h2">{`UxpMenuItems`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Get panel menu items`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      